import React from "react";
import { observer } from "mobx-react-lite";
import { Intent, TextArea } from "@blueprintjs/core";
import { FormGroupWithRequired } from "./Components";
import type { ITextAreaAttrEditorProps, EditorWithFormGroup } from "./_types";

// TextAreaAttrEditor
export const TextAreaAttrEditor = observer(<D, K extends keyof D>(props: ITextAreaAttrEditorProps<D, K>) => {
	const { store, ...rest } = props;

	// Change handler
	const onChange = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (props.textAreaProps?.onChange) props.textAreaProps.onChange(ev);
		else store.set(props.name, ev.target.value);
	};

	// --

	return <TextArea onChange={onChange} value={(store.data[props.name] as string) ?? ""} {...rest.textAreaProps} name={rest.name as string} />;
});

// TextAreaAttrEditorGrouo
export const TextAreaAttrEditorGroup = <D, K extends keyof D>(props: EditorWithFormGroup<ITextAreaAttrEditorProps<D, K>>) => {
	// --

	return (
		<FormGroupWithRequired required={props.textAreaProps.required} {...props.formGroupProps}>
			<TextAreaAttrEditor store={props.store} name={props.name as any} textAreaProps={props.textAreaProps} />
		</FormGroupWithRequired>
	);
};

// TextAreaAttrEditorGrouoWithError
export const TextAreaAttrEditorGroupWithError = observer(<D, K extends keyof D>(props: EditorWithFormGroup<ITextAreaAttrEditorProps<D, K>>) => {
	const error = props.store.validation.errors.get(props.name);
	const intent: Intent = error ? "danger" : props.textAreaProps.intent;

	// --

	return (
		<FormGroupWithRequired
			required={props.textAreaProps.required}
			{...props.formGroupProps}
			helperText={<span dangerouslySetInnerHTML={{ __html: error ?? (props.formGroupProps.helperText as any) ?? "&nbsp;" }} />}
			intent={intent}
		>
			<TextAreaAttrEditor store={props.store} name={props.name as any} textAreaProps={props.textAreaProps} />
		</FormGroupWithRequired>
	);
});
